import { render, staticRenderFns } from "./ListPickup.vue?vue&type=template&id=b8deace8&scoped=true&"
import script from "./ListPickup.vue?vue&type=script&lang=js&"
export * from "./ListPickup.vue?vue&type=script&lang=js&"
import style0 from "./ListPickup.vue?vue&type=style&index=0&id=b8deace8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8deace8",
  null
  
)

export default component.exports